import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationManager } from 'react-notifications';
import base from '@/_api/base';
import { useApiMutation } from '@/hooks/api/useApiMutation';
import { useGetQuery } from '@/hooks/api/useGetQuery';
import { queryKeys } from '../query-keys';

export function useAllVendorsQuery() {
  return useGetQuery(() => '/admin/vendors', {}, queryKeys.vendors(), {});
}

export function useVendorCategoriesQuery() {
  return useGetQuery(
    () => '/admin/vendor-categories',
    {},
    queryKeys.vendorCategories(),
    {},
  );
}

export function useFestivalVendorsQuery(festivalId) {
  return useGetQuery(
    () => `/admin/vendors/${festivalId}`,
    {},
    queryKeys.festivalVendors(festivalId),
    { enabled: festivalId != null && festivalId !== '' },
  );
}

export function useSaveVendorMutation() {
  const queryClient = useQueryClient();
  return useApiMutation(
    (vendor) => '/admin/vendor',
    'post',
    {},
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: queryKeys.vendors() });
        NotificationManager.success('Vendor saved', '', 3000);
      },
      onError: () => {
        NotificationManager.error('Vendor could not be saved', '', 3000);
      },
    },
  );
}

export function useSaveFestivalVendorMutation(festivalId) {
  const queryClient = useQueryClient();
  return useApiMutation(
    (vendor) => `/admin/vendor/${festivalId}`,
    'post',
    {},
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.festivalVendors(festivalId),
        });
        queryClient.invalidateQueries({ queryKey: queryKeys.vendors() });
        NotificationManager.success('Vendor saved', '', 3000);
      },
      onError: () => {
        NotificationManager.error('Vendor could not be saved', '', 3000);
      },
    },
  );
}

export function useRemoveFestivalVendorMutation(festivalId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (vendorId) =>
      base.delete(`/admin/vendor/${festivalId}/${vendorId}`, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.festivalVendors(festivalId),
      });
      NotificationManager.success('Vendor removed', '', 3000);
    },
    onError: () => {
      NotificationManager.error('Vendor could not be removed', '', 3000);
    },
  });
}
